module.exports = __webpack_public_path__ + "static/media/TURISMO_8.7ed8dd0a.png";